<!-- =========================================================================================
  File Name: PondView.vue
  Description: Pond View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-pond-view" class="data-list-container">
		<vs-table class="shadow-none border-none" stripe :data="ponds">
			<template slot="thead">
				<vs-th><h6 class="font-bold">Khu/Ao</h6></vs-th>
				<vs-th><h6 class="font-bold">Diện tích (m2)</h6></vs-th>
				<vs-th><h6 class="font-bold">Cỡ cá (gr)</h6></vs-th>
				<vs-th><h6 class="font-bold">Sản lượng (kg)</h6></vs-th>
				<vs-th></vs-th>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickItemRow($event, tr)">
					<vs-td>{{ customPondName(tr) }}</vs-td>

					<vs-td class="">
						<p class="word-break">{{ $helper.numFormat(tr.area) }}</p>
					</vs-td>

					<vs-td>
						<p class="word-break">{{ tr.fishGrow && tr.fishGrow.overview ? $helper.numFormat(tr.fishGrow.overview.weight) : "" }}</p>
					</vs-td>

					<vs-td class="">
						<p class="word-break">{{ tr.fishGrow && tr.fishGrow.overview ? $helper.numFormat(tr.fishGrow.overview.estYield) : "" }}</p>
					</vs-td>
					<!-- <vs-td class="flex justify-end ">
						<i @click.stop="showDeletePondConfirm(tr)" class="nucleo mr-3 text-primary nucleo-trash-can cursor-pointer" />
					</vs-td> -->
					<vs-td class="flex justify-end">
						<i @click.stop="handleShowUpdatePond(tr)" class="nucleo mr-4 text-primary nucleo-edit cursor-pointer" />
						<i @click.stop="showDeletePondConfirm(tr)" class="nucleo mr-4 text-primary nucleo-trash-can cursor-pointer" />
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
		<div class="w-full center mt-4">
			<!-- <CbsPagination :total="total" v-model="page"></CbsPagination> -->
		</div>
		<PondDetail v-if="isDetailPondDialogActive" :data="detailPondDialogData" :isSidebarActive="isDetailPondDialogActive" @closeSidebar="toggleDetailSidebar" />
		<PondUpdate v-if="isUpdatePondDialogActive" :data="detailPondDialogData" :isPopupActive="isUpdatePondDialogActive" @closePopup="toggleDetailSidebarPond" />
	</div>
</template>

<script>
import BasicContextMenu from "@/components/basic-context-menu/BasicContextMenu";
import CbsPagination from "@/components/cbs-pagination/CbsPagination";
import PondDetail from "./PondDetail.vue";
import PondUpdate from "./PondUpdate.vue";
// import * as _ from "lodash";
export default {
	components: { BasicContextMenu, CbsPagination, PondDetail, PondUpdate },
	data() {
		return {
			page: 1,
			searchText: "",
			pondDialog: false,
			pondData: {},
			detailPondDialogData: null,
			isDetailPondDialogActive: false,
			isUpdatePondDialogActive: false
		};
	},
	computed: {
		total() {
			return Math.ceil(this.$store.state.modulePond.total / this.$store.state.modulePond.limit);
		},
		ponds() {
			if (this.$store.state.modulePond && this.$store.state.modulePond.ponds) {
				return this.$store.state.modulePond.ponds;
				// return _.sortBy(this.$store.state.modulePond.ponds, item => item.name);
			} else {
				return [];
			}
		}
	},
	methods: {
		async handleShowUpdatePond(pond) {
			// const eventClasses = event.target && event.target.className;
			this.$vs.loading();
			const param = `${pond._id}?projection={"lastUpdatedOverview":1,"name":1,"stocking.data":{"$slice":1},"feeding.data":{"$slice":-1},"feeding.overview":1,"fishLoss.data":{"$slice":-1},"fishLoss.overview":1,"fishGrow.overview":1,"fishGrow.data":{"$slice":-1},"enviroment.data":{"$slice":-1},"notes.data":{"$slice":-1},"lastUpdatedOverview":1}`;
			const _pond = await this.$store.dispatch("modulePond/fetchPond", param);
			console.log("fetchPond", _pond);
			this.detailPondDialogData = Object.assign(pond, _pond);
			console.log("[handleClickItemRow]", this.detailPondDialogData);
			this.toggleDetailSidebarPond(true);
			this.$vs.loading.close();
		},
		toggleDetailSidebarPond(val = false) {
			this.isUpdatePondDialogActive = val;
		},
		customPondName(pond) {
			return pond && pond.zone ? `${pond.zone} - ${pond.name}` : pond.name || '';
		},
		async getGetPonds() {
			this.$vs.loading();
			const payload = {
				filters: {},
				sort: {
					"_id.id": -1
				},
				paging: {
					page: this.page,
					limit: this.$store.state.modulePond.limit
				}
			};
			try {
				await this.$store.dispatch("modulePond/fetchPonds", payload);
				this.$vs.loading.close();
			} catch (error) {
				console.error("err fetchPonds", error);
				this.$vs.loading.close();
			}
		},
		handleSearch() {},

		addNewPond() {
			this.pondData = {};
			this.togglePondDialog(true);
		},
		async editPond(pond) {
			const _pond = await this.$store.dispatch("modulePond/fetchPond", pond._id);
			console.log("[editPond]", _pond);
			this.pondData = _pond;
			this.togglePondDialog(true);
		},

		togglePondDialog(val = false) {
			this.pondDialog = val;
		},
		showDeletePondConfirm(pond) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deletePond(pond._id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		async deletePond(pondId) {
			console.log("[View] deletePond", pondId);
			this.$vs.loading();
			try {
				await this.$store.dispatch("modulePond/removeRecord", pondId);
				this.$vs.loading.close();
			} catch (error) {
				console.error("[View] deletePond", error);
				this.$vs.loading.close();
			}
		},
		async handleClickItemRow(event, pond) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not below classes
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find(className => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
				this.$vs.loading();
				const param = `${pond._id}?projection={"lastUpdatedOverview":1,"customer":1, "name":1,"area":1,"stocking.data":1,"feeding.overview.totalQty":1,"fishGrow.overview":1,"fishLoss.overview":1,"harvests":1}`;
				const _pond = await this.$store.dispatch("modulePond/fetchPond", param);
				console.log("fetchPond", _pond);
				this.detailPondDialogData = Object.assign(pond, _pond);
				console.log("[handleClickItemRow]", this.detailPondDialogData);
				this.toggleDetailSidebar(true);
				this.$vs.loading.close();
			}
		},
		toggleDetailSidebar(val = false) {
			this.isDetailPondDialogActive = val;
		}
	},
	watch: {
		page() {
			this.getGetPonds();
		}
	},
	created() {
		// Register Module PondManagement Module
	}
};
</script>

<style lang="scss">
#avatar-col {
	width: 10rem;
}

#page-pond-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		// &:not(.permissions-table) {
		// 	td {
		// 		@media screen and (max-width: 370px) {
		// 			display: block;
		// 		}
		// 	}
		// }
	}
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px), only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}

	// #account-manage-buttons {
	//   width: 12rem !important;
	//   flex-direction: column;

	//   > button {
	//     margin-right: 0 !important;
	//     margin-bottom: 1rem;
	//   }
	// }
}
</style>
